import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { css } from '@bd/bdui-styles/emotion';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { getPlanRouteProps } from '@bd/bdcore-data/build/Plans/selectors';

import { colors } from '../styles';

const styles = css`
  width: 100%;
  height: 100%;
  padding: 0 0 30px 0;
  .HomeCard_wrapper {
    display: flex;
    height: 100%;
  }
  .HomeCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #F3F3F3;
  }
  .HomeCard_media {
    padding: 10px;
    position: relative;
    img {
      width: 100%;
      height: 213px;
      object-fit: cover;
    }

    .HomecardPromo-overlay {
      position: absolute;
      top: 179px;
      background-color: rgba(0, 0, 0, 0.85) !important;
      width: calc(100% - 20px);
      color: rgb(255, 255, 255);
      font-weight: 800;
      text-transform: uppercase;
      display: block;
      -webkit-box-align: center;
      align-items: center;
      padding: 5px 30px;
      text-align: center;
    }
    .HomecardImage-overlay {
      position: absolute;
      top: 10px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.6);
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${colors.white};
      text-transform: uppercase;
      font-size: 13px;
      padding: 5px 10px;
      img {
        width: 20px;
        height: auto;
        margin-right: 6px;
      }
    }
  }
  .HomeCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    h4 {
      font-weight: bold;
      font-size: 20px;
      line-height: 22px;
      letter-spacing: 0;
      background-color: #E9EAEA;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px 0 15px;
      height: 80px;
      @media(min-width: 450px) {
        padding: 0 10px 0 30px;
      }
      span {
        font-size: 15px;
        font-weight: bold;
        color: ${colors.brand1};
        letter-spacing: 0;
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand1Lighter};
          transition: all .3s ease-out;
        }
      }
      a {
        color: ${colors.brand1};
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand1Lighter};
          transition: all .3s ease-out;
        }
      }
    }
    .HomeLinksWrapper {
      width: 100%;
      padding: 0 10px 0 15px;
      display: flex;
      flex-direction: column;
      @media(min-width: 450px) {
        padding: 0 10px 0 30px;
      }
      span {
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0;
      }

      a {
        font-weight: 400;
        font-size: 16px;
        color: ${colors.brand1};
        letter-spacing: 0;
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand1Lighter};
          transition: all .3s ease-out;
        }
      }
    }
    .HomeCardPriceSection {
      padding: 10px 10px 10px 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      @media(min-width: 450px) {
        padding: 0 10px 0 30px;
        flex-direction: row;
        height: 55px;
      }

      .HomeCardPriceWrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        order: 1;
        padding-top: 10px;
        @media(min-width: 450px) {
          padding-top: 0;
          flex-direction: column;
          align-items: flex-start;
          order: 0;
        }

        span {
          font-weight: bold;
          color: ${colors.body};
        }

        h3 {
          font-weight: 300;
          font-size: 20px;
          color: #353637;
          letter-spacing: 0;
          margin-bottom: 0;
          @media(min-width: 450px) {
            font-size: 24px;
          }
        }
      }
      .HomeCardHomeStatus {
        width: 160px;
        background-color: #E9EAEA;
        height: 40px;
        font-weight: bold;
        font-size: 14px;
        color: ${colors.brand1};
        letter-spacing: 0;
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        @media(min-width: 450px) {
          padding: 0;
        }
      }
    }
    .HomeCard_textList {
      list-style: none;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid ${colors.neutral};
      flex-grow: 1;
      li {
        font-size: 13px;
        font-weight: 300;
        line-height: 1;
        border-top: 1px solid ${colors.neutral};
        padding: 10px;
        a {
          color: ${colors.brand1};
        }
      }
    }
    .HomeCard_iconList {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0 5px 0 15px;
      border-top: 1px solid ${colors.neutral};
      border-bottom: 1px solid ${colors.neutral};
      height: 72px;
      align-items: center;
      height: 105px;
      @media(min-width: 450px) {
        padding: 0;
      }
      li {
        text-align: left;
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px solid ${colors.neutral};
        &:last-child {
          border-right: 0;
        }
        span {
          display: block;
          font-weight: 500;
        }
        b {
          font-weight: bold;
        }
        &:last-child {
          width: 40%;
        }
        img {
          height: 20px;
          width: auto;
        }
        .HomeCard_iconListValue {
          font-size: 15px;
          color: #353637;
          letter-spacing: 0;
        }
        a {
          color: ${colors.brand1};
          font-weight: 700;
        }
        .HomeCard_linkIcon {
          width: 13px;
          height: 13px;
          margin: 5px 0 0 0;
        }
      }
    }
    .HomeCard_buttonWrapper {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      .HomeCard_mapButton {
        width: 40px;
        height: 40px;
        background-color: ${colors.brand1};
        background-image: url('/images/icon-map-pin-white.svg');
        background-position: center center;
        background-repeat: no-repeat;
        display: block;
      }
      .HomeCard_detailButton {
        flex-grow: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: ${colors.brand1};
        color: #FFFFFF;
        font-weight: 700;
        font-size: 15px;
      }
    }
  }
  .ViewHomeBtn {
    height: 60px;
    background-color: ${colors.brand1};
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: ${colors.white};
    letter-spacing: 0;
    text-transform: uppercase;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand1};
      transition: all .3s ease-out;
    }
  }
`;

function HomeCard({ community, home, plan }) {
  const garages = get(home, 'garages_range') || get(home, 'garages');
  const beds = get(home, 'beds_range') || get(home, 'beds');
  // const bathrooms = `${get(home, 'bathsFull', '')}
  // ${get(home, 'bathsThreeQuarter', '') && !get(home, 'bathsHalf') ? '.75' : ''}
  // ${get(home, 'bathsHalf', '') && '.5'}`;
  return (
    <div className={styles}>
      <div className="HomeCard_wrapper">
        <div className="HomeCard_inner">
          <div className="HomeCard_media">
            <Link name="home-detail" home={home}>
              <Image
                src={get(home, 'photos[0].contentUrl')}
                alt={get(home, 'address.streetAddress')}
                width={475}
                height={315}
                exact
              />
              <span className="HomecardImage-overlay">
                <img src="/images/icon-photo.svg" alt="LightBox Icon" />
                {get(home, 'photos').length} {get(home, 'photos').length === 1 ? 'Photo' : 'Photos'}
              </span>
              {
                get(home, 'headline') &&
                <span className="HomecardPromo-overlay"> {get(home, 'headline')} </span>
              }
            </Link>
          </div>
          <div className="HomeCard_content">
            <h4>
              <Link name="home-detail" home={home}>
                {get(home, 'address.streetAddress')}<br />
                <span>{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}</span>
              </Link>
              <a href={GoogleMapUrl(home)} target="_blank" rel="noopener noreferrer" className="HomeCard_mapButton">
                <div className="sr-only">Google Map Link</div>
              </a>
            </h4>
            <div className="HomeLinksWrapper">
              {
                get(community, 'name') &&
                <span>Community: <Link name="community-detail" community={community}>{get(community, 'name')}</Link></span>
              }
              {
                get(plan, 'name') &&
                <span>Plan: <Link name="plan-detail" params={getPlanRouteProps(plan, { community })}>{get(plan, 'name')}</Link> | Lot: {get(home, 'lot')}</span>
              }
              {
                get(home, 'moveInDate') &&
                  <span>Completion Date: <b>{moment(get(home, 'moveInDate')) <= moment() ? 'Ready Now' : moment(get(home, 'moveInDate')).format('MM/DD/YYYY')}</b></span>
              }
            </div>
            <ul className="HomeCard_iconList">
              {
                beds &&
                <li>
                  <img src="/images/icon-beds.svg" alt="Icon Beds" />
                  <span className="HomeCard_iconListValue"><b>{beds}</b></span>
                  <span className="HomeCard_iconListValue">Beds</span>
                </li>
              }
              {
                get(home, 'custom_baths') &&
                <li>
                  <img src="/images/icon-baths.svg" alt="Icon Baths" />
                  <span className="HomeCard_iconListValue"><b>{get(home, 'custom_baths')}</b></span>
                  <span className="HomeCard_iconListValue">Baths</span>
                </li>
              }
              {/* {
                !get(home, 'custom_baths') &&
                <li>
                  <img src="/images/icon-baths.svg" alt="Icon Baths" />
                  <span className="HomeCard_iconListValue"><b>{bathrooms}</b></span>
                  <span className="HomeCard_iconListValue">Baths</span>
                </li>
              } */}
              {
                !get(home, 'custom_baths') &&
                <li>
                  <img src="/images/icon-baths.svg" alt="Icon Baths" />
                  <span className="HomeCard_iconListValue">
                    <span className="d-flex">
                      {
                        get(home, 'bathsFull', '') &&
                        <div><b>{get(home, 'bathsFull', '')}</b> Full</div>
                      }
                      {
                        get(home, 'bathsThreeQuarter') &&
                        <div className="px-2"><b>{get(home, 'bathsThreeQuarter', '')}</b> &frac34;</div>
                      }
                      {
                        get(home, 'bathsHalf', '') &&
                        <div><b>{get(home, 'bathsHalf', '')}</b> Half</div>
                      }
                    </span>
                  </span>
                  <span className="HomeCard_iconListValue">Baths</span>
                </li>
              }
              {
                get(home, 'sqft') &&
                <li>
                  <img src="/images/icon-sqft.svg" alt="Icon Sqft" />
                  <span className="HomeCard_iconListValue"><b>{numeral(get(home, 'sqft')).format('0,0')}</b></span>
                  <span className="HomeCard_iconListValue">SQFT</span>
                </li>
              }
              {
                garages &&
                <li>
                  <img src="/images/icon-garages.svg" alt="Icon Garage" />
                  <span className="HomeCard_iconListValue"><b>{garages}</b></span>
                  <span className="HomeCard_iconListValue">Cars</span>
                </li>
              }
            </ul>
            <div className="HomeCardPriceSection">
              <div className="HomeCardPriceWrapper">
                {get(home, 'price') > 0 &&
                <h3 className="HomeCard_priceValue">Price: <span>{numeral(get(home, 'price')).format('$0,0')}</span></h3>
                }
                {(!get(home, 'price') || get(home, 'price') === 0) &&
                <h3 className="HomeCard_priceValue">Price: <span>Call for Details</span></h3>
                }
              </div>
              {
                get(home, 'previous_price') &&
                <div className="HomeCardHomeStatus">
                  <span>Was: {numeral(get(home, 'previous_price')).format('$0,0')}</span>
                </div>
              }
            </div>
            <Link name="home-detail" home={home} className="ViewHomeBtn">View Details</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeCard.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object,
};

HomeCard.defaultProps = {
  plan: undefined,
  community: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
  },
  {
    required: {
      home: true,
    },
  },
)(HomeCard);



// WEBPACK FOOTER //
// ./src/components/HomeCard.js